import { Code, KeyBlue, UserSettings } from "assets/images";
import { useEffect, useState } from "react";
import LogOutModal from "utils/other/LogOutModal";
import {
  useProfileQuery,
  useLazyProfileUpdateQuery,
  useProfileUpdatePasswordMutation,
} from "redux/RTQ/IlenkradApi";
import { ToastDanger, ToastSuccess } from "utils/toast/Toast";
import lottieJson from "assets/gifs/dottedBtn.json";
import Lottie from "react-lottie-player";
import SuccessModalPc from "pagesPc/utils/modalCommonPc/SuccessModalPc";
import LoadingLottie from "components/lottieLoading/LoadingLottie";
import { FixSimNumbers } from "common/common";

const ProfilePc = ({
  closeDrawer,
  setNewPhoneNumber,
  phone_number_changed,
  setPhoneNumberChanged,
  setOpenModalOpt,
}: any) => {
  const [name, setName] = useState<string>("");
  const [showChangePassword, setShowChangePassword] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const showChangePasswordPage = () => {
    setShowChangePassword(!showChangePassword);
  };
  const [phone_number, setPhoneNumber] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [oldPassword, setOldPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [openModalSuccess, setOpenModalSuccess] = useState<boolean>(false);
  const [openModalLogout, setOpenModalLogout] = useState<boolean>(false);
  const [mfa_enabled, setTwoStepVerification] = useState<boolean>(false);

  const showModalLogout = () => {
    setOpenModalLogout(!openModalLogout);
  };
  const showModalSuccess = () => {
    setOpenModalSuccess(!openModalSuccess);
  };

  const { data: userData, isLoading, isSuccess, refetch } = useProfileQuery();
  useEffect(() => {
    refetch();
  }, []);

  const checkValidationPassword = (value: string) => {
    if (value) {
      if (/^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$).{7,15}$/.test(value)) {
        return { isError: false, errorText: "" };
      } else {
        return {
          isError: true,
          errorText:
            "رمز عبور باید حداقل ۷ کاراکتر و حداکثر ۱۵ کاراکتر و حداقل شامل یک حرف و یک عدد باشد",
        };
      }
    } else {
      return {
        isError: true,
        errorText: "وارد کردن این فیلد الزامیست",
      };
    }
  };

  const checkValidationName = (value: string) => {
    if (value) {
      if (name.length >= 3 && name.length < 100) {
        return { isError: false, errorText: "" };
      } else {
        return {
          isError: true,
          errorText:
            "نام و نام‌خانوادگی حداقل ۳ کاراکتر و حداکثر ۱۰۰ کاراکتر می باشد",
        };
      }
    } else {
      return {
        isError: true,
        errorText: "وارد کردن این فیلد الزامیست",
      };
    }
  };
  const [
    mutateUpdatePass,
    { isLoading: isLoadingUpdatePass, isSuccess: isSuccessUpdatePassword },
  ] = useProfileUpdatePasswordMutation();
  const submitPassword = () => {
    const checkedPassword = checkValidationPassword(password);
    const checkedOldPassword = checkValidationPassword(oldPassword);
    if (confirmPassword !== password) {
      setError(true);
      ToastDanger("تکرار رمز و رمز مطابقت ندارند");
      return;
    }
    if (!checkedPassword.isError && !checkedOldPassword.isError) {
      const obj: any = { new_password: password, old_password: oldPassword };
      mutateUpdatePass(obj);
    } else {
      setError(true);
    }
  };
  const clearPassword = () => {
    setPassword("");
    setOldPassword("");
    setConfirmPassword("");
    setError(false);
  };
  useEffect(() => {
    const userDataSuccess: any = userData;
    if (isSuccess) {
      setName(userDataSuccess?.user.name);
      setPhoneNumber(userDataSuccess?.user.phone_number);
      setTwoStepVerification(userDataSuccess.user.mfa_enabled);
    }
  }, [isSuccess, userData]);
  useEffect(() => {
    if (isSuccessUpdatePassword) {
      clearPassword();
      ToastSuccess("رمز شما با موفقیت تغییر یافت");
      setShowChangePassword(false);
    }
  }, [isSuccessUpdatePassword]);
  const checkValidationPhone = (value: string) => {
    if (value) {
      if (value.length === 13) {
        return { isError: false, errorText: "" };
      } else {
        return {
          isError: true,
          errorText: "شماره موبایل صحیح نیست",
        };
      }
    } else {
      return {
        isError: true,
        errorText: "وارد کردن این فیلد الزامیست",
      };
    }
  };
  const [
    mutateUpdate,
    {
      data: dataUpdateProfile,
      isSuccess: isSuccessUpdateProfile,
      isLoading: isLoadingUpdateProfile,
      error: erUpdateProfile,
    },
  ] = useLazyProfileUpdateQuery();

  const submitProfile = () => {
    const userDataSuccess: any = userData;
    const checkedPhone = checkValidationPhone(phone_number);
    const checkedName = checkValidationName(name);
    if (!checkedPhone.isError && !checkedName.isError) {
      if (phone_number !== userDataSuccess?.user.phone_number) {
        setNewPhoneNumber(phone_number);
        setOpenModalOpt(true);
      } else {
        const obj = { name, phone_number, mfa_enabled };
        mutateUpdate(obj);
      }
    } else {
      setError(true);
    }
  };
  useEffect(() => {
    const userUpdateDataSuccess: any = dataUpdateProfile;
    if (isSuccessUpdateProfile) {
      showModalSuccess();
      localStorage.removeItem("otpTime");
      setName(userUpdateDataSuccess?.user.name);
      setPhoneNumber(userUpdateDataSuccess?.user.phone_number);
      setTwoStepVerification(userUpdateDataSuccess?.user.mfa_enabled);
    }
  }, [isSuccessUpdateProfile, erUpdateProfile]);

  useEffect(() => {
    if (phone_number_changed) {
      const obj = { name, phone_number, mfa_enabled };
      mutateUpdate(obj);
      setPhoneNumberChanged(false);
    }
  }, [phone_number_changed]);

  if (isLoading) {
    return <LoadingLottie />;
  }
  return (
    <>
      <SuccessModalPc
        open={openModalSuccess}
        onClose={showModalSuccess}
        title="پروفایل با موفقیت تغییر یافت"
      />
      <div className="rowheaderModalSettingMap">
        <div onClick={closeDrawer} className="icon3-close pointer" />
        <div className="titleheaderModalPc">
          {!showChangePassword ? "ویرایش اطلاعات کاربری" : "ویرایش پسورد"}
        </div>
      </div>
      <LogOutModal open={openModalLogout} onClose={showModalLogout} />
      <div
        style={{
          pointerEvents:
            isLoading || isLoadingUpdateProfile || isLoadingUpdatePass
              ? "none"
              : "initial",
        }}
        className="contentListTracker scrollbar-div"
      >
        {showChangePassword ? (
          <>
            <div className="profileRowContainer">
              <div className="lablePasswordProfile">رمز عبور فعلی</div>
              <div className="profileIconContainerBlue">
                <img src={KeyBlue} className="profileIconImage" alt="icon" />
              </div>
              <input
                disabled={isLoadingUpdateProfile}
                maxLength={15}
                minLength={5}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                className={
                  error && checkValidationPassword(oldPassword).isError
                    ? "profileInputError"
                    : "profileInput"
                }
                type="password"
                placeholder="***********"
              />
              <div className="changePasswordErrorInput">
                {error ? checkValidationPassword(oldPassword).errorText : null}
              </div>
            </div>
            <div className="profileRowContainer mt-2-profile">
              <div className="lablePasswordProfile">رمز عبور جدید</div>

              <div className="profileIconContainerBlue">
                <img src={KeyBlue} className="profileIconImage" alt="icon" />
              </div>

              <input
                disabled={isLoadingUpdateProfile}
                maxLength={15}
                minLength={5}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={
                  error && checkValidationPassword(password).isError
                    ? "profileInputError"
                    : "profileInput"
                }
                type="password"
                placeholder="***********"
              />
              <div className="changePasswordErrorInput">
                {error ? checkValidationPassword(password).errorText : null}
              </div>
            </div>
            <div className="profileRowContainer mt-2-profile">
              <div className="lablePasswordProfile">تکرار رمز عبور</div>

              <div className="profileIconContainerBlue">
                <img src={KeyBlue} className="profileIconImage" alt="icon" />
              </div>

              <input
                disabled={isLoadingUpdateProfile}
                maxLength={15}
                minLength={5}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={
                  error && checkValidationPassword(confirmPassword).isError
                    ? "profileInputError"
                    : "profileInput"
                }
                type="password"
                placeholder="***********"
              />
              <div className="changePasswordErrorInput">
                {error
                  ? checkValidationPassword(confirmPassword).errorText
                  : null}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="profileRowContainer">
              <div className="lablePasswordProfile">نام و نام خانوادگی</div>
              <div className="profileIconContainerGreen">
                <img
                  src={UserSettings}
                  className="profileIconImage"
                  alt="icon"
                />
              </div>
              <input
                type="text"
                disabled={isLoading}
                onChange={(e) => setName(e.target.value)}
                value={name}
                maxLength={100}
                className={
                  error && checkValidationName(name).isError
                    ? "profileInputError dir"
                    : "profileInput dir"
                }
              />
              <div
                style={{ position: "absolute", right: "4rem" }}
                className="icon5-edit"
              />
              <div className="inputErrorContainerProfile">
                {error ? checkValidationName(name).errorText : null}
              </div>
            </div>

            <div className="profileRowContainer mt-2-profile">
              <div className="lablePasswordProfile">شماره تلفن همراه</div>
              <div className="profileIconContainerYellow">
                <img src={Code} className="profileIconImage" alt="icon" />
              </div>
              <input
                inputMode="numeric"
                disabled={isLoading}
                maxLength={13}
                value={phone_number}
                onChange={(e) => setPhoneNumber(FixSimNumbers(e.target.value))}
                className={
                  error && checkValidationName(name).isError
                    ? "profileInputError dir"
                    : "profileInput dir"
                }
              />
              <div
                style={{ position: "absolute", right: "4rem" }}
                className="icon5-edit"
              />
              <div className="inputErrorContainerProfile">
                {error ? checkValidationPhone(phone_number).errorText : null}
              </div>
            </div>
          </>
        )}

        <div className="profileRowContainerBottom">
          <div
            onClick={showModalLogout}
            className="rowLogoutProfileMobile pointer"
          >
            <div className="icon-logout profileIconLogout" />
            <div className="profileBottomTxt">خروج از حساب کاربری</div>
          </div>
          <div
            onClick={showChangePasswordPage}
            className="underInputChangePass pointer"
          >
            {showChangePassword ? "تغییر اطلاعات کاربری" : "تغییر رمز عبور"}
          </div>
        </div>

        <div className="profileRowContainerButtons">
          <div
            onClick={() => {
              if (showChangePassword) {
                submitPassword();
              } else {
                submitProfile();
              }
            }}
            className="profileSubmitButtonPc"
          >
            {isLoadingUpdateProfile ? (
              <div className="containerLottieDoted">
                <Lottie
                  loop
                  animationData={lottieJson}
                  play
                  className="dotedLottie"
                />
              </div>
            ) : showChangePassword ? (
              "ثبت رمز عبور جدید"
            ) : (
              "ویرایش اطلاعات"
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfilePc;
